import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../common/molecules/Modal/view/Modal';
import Image from '../../../../../common/atoms/Image';
import StyledViewMapModal from '../styles/ViewMapModal.style';

const ViewMapModal = ({ isOpen, onRequestClose, viewMapImageUrl }) => {
  return (
    <Modal
      colSet={{ large: 6, medium: 8, small: 6 }}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="TCPModal__Overlay"
    >
      <StyledViewMapModal>
        <Image src={viewMapImageUrl} alt={'view-map-image'} />
      </StyledViewMapModal>
    </Modal>
  );
};

ViewMapModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  viewMapImageUrl: PropTypes.string.isRequired,
};

export default ViewMapModal;
